<template>
  <div class="uploadImage">
    商品主图：<br><br>
    <el-upload
      ref="uploadImage"
      :action="$global.httpBaseURL + $global.uploadPath"
      :file-list="fileList"
      :before-upload="beforeAvatarUpload"
      list-type="picture-card"
      :on-change="handleChange"
      :class="{hide:hideUpload}"
      :disabled="isAdmin">
        <i slot="default" class="el-icon-plus"></i>
        <div slot="file" slot-scope="{file}">
          <img class="el-upload-list__item-thumbnail" :src="file.url" >
          <span class="el-upload-list__item-actions">
            <span class="el-upload-list__item-preview" @click="handelPreview(file)">
              <i class="el-icon-zoom-in"></i>
            </span>
            <span class="el-upload-list__item-delete" v-if="!isAdmin" @click="handleRemove(file)" >
              <i class="el-icon-delete"></i>
            </span>
          </span>
        </div>
    </el-upload>
    <span>建议 ＜3M，最多3张</span>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl">
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['list'],
  data () {
    return {
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: '',
      hideUpload: false
    }
  },
  watch: {
    list: {
      deep: true,
      handler (val) {
        this.fileList = val
        this.handleChange(null, val)
      }
    }
  },
  computed: {
    // 账号权限
    isAdmin () {
      return window.localStorage.getItem('identity') === '3'
    }
  },
  methods: {
    // 放大图片
    handelPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 删除
    handleRemove (file, fileList) {
      let currentUrl = file.submitUrl || file.response.obj
      this.$refs.uploadImage.uploadFiles.map((item, index) => {
        let url = item.submitUrl || item.response.obj
        if (currentUrl === url) {
          this.$refs.uploadImage.uploadFiles.splice(index, 1)
        }
      })

      this.handleChange(null, this.getFileList(true))
    },
    // 文件上传3张后 隐藏上传按钮
    handleChange (file, fileList) {
      if (file && (file.raw.type.indexOf('image') === -1 || file.size > this.limitImgSize())) {
        this.hideUpload = false
        return false
      }
      this.hideUpload = fileList.length >= 3
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type.indexOf('image') > -1
      const isLt4M = this.limitImgSize(file.size)
      const isLimit = this.getFileList(true).length <= 3
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG和png 格式!')
      }
      if (!isLt4M) {
        this.$message.error('上传头像图片大小不能超过 3MB!')
      }
      if (!isLimit) {
        this.$message.error('最多上传3张图片')
      }
      return isJPG && isLt4M && isLimit
    },
    // 限制图片大小为3M
    limitImgSize (size) {
      let imgSize = 3
      if (size) {
        return size / 1024 / 1024 < imgSize
      }
      return imgSize * 1024 * 1024
    },
    // 获取图片集合
    getFileList (type) {
      let fileList = this.$refs.uploadImage.$refs['upload-inner'].fileList
      if (type) {
        return fileList
      }
      let result = this.$refs.uploadImage.$refs['upload-inner'].fileList.map(item => {
        return item.submitUrl || item.response.obj
      })
      return result.join(',')
    }

  }
}
</script>

<style>

.hide .el-upload--picture-card {
  display: none;
}
.uploadImage .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    height: auto;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/page/goodsManage/components/uploadImage.vue